import WidgetView from '../widget-view'
import EmbeddedContentConfig from './embedded-content-config'
import template from './embedded-content-view.hbs'
import iframeTemplate from 'scoreboard/components/embedded-iframe.hbs'
import _ from 'lodash'
import { EMBEDDED_URL_LOAD_DELAY } from 'scoreboard/components/export/send-to-export'
import layoutManager from 'scoreboard/components/layout-manager'

/**
 * Backbone.View for embedded-content widgets
 */
const EmbeddedContentView = WidgetView.extend({
	className: 'widget embedded-content',
	configClass: EmbeddedContentConfig,

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		this._draw()

		return this
	},

	_draw: function () {

		if (this.$('.content').length === 0) {
			this.$el.append(template())

			// #50962 remove this once iframe export is fixed
			if (layoutManager.export) {
				this.readyForDisplayAndExport()
				return
			}

			this.$('.site-container').append(iframeTemplate())

			// once the iframe is loaded, it's ready for export
			this.$('iframe').on('load', () => {
				// https://github.com/SpiderStrategies/Scoreboard/issues/28362#issuecomment-583000822
				console.log('Waiting', EMBEDDED_URL_LOAD_DELAY, 'milliseconds to capture iframe for export.')
				setTimeout(this.readyForExport.bind(this), EMBEDDED_URL_LOAD_DELAY)
			})
		}

		let src = this.model.src()
		let isImage = this.model.isImage()

		if (isImage) {
			// #23573 if the URL points to an image (determined by URL extension),
			// render it as the background image in a div so it will scale to fill
			// the wob's dimensions
			this.$('.image').css('background-image', `url('${src}')`)
		} else {
			if (this.$('iframe').attr('src') !== src) {
				this.$('iframe').attr('src', src)
			}
		}

		this.$('.site-container').toggleClass('is-not-displayed', isImage)
		this.$('.image-container').toggleClass('is-not-displayed', !isImage)

		this._renderTitle()

		// The iframe loads asynchronously, so it isn't ready for export,
		// but it can still be displayed
		this.readyForDisplay()
	},

	_renderTitle () {
		let title = this.model.properties.get('label')

		this.$('.title-text h3').text(title)
		this.$el.toggleClass('has-title', !_.isNil(title))
	}
})

export default EmbeddedContentView

EmbeddedContentView.__filename__ = 'dashboards/widgets/embedded-content/embedded-content-view.js'
